import * as React from 'react';
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from "react-i18next";
import ProcessingRequestRow from "../components/ProcessingRequestRow.jsx";
import { Table, TableBody, TableCell, TableHead, TableRow, Card } from '@mui/material';

export default function ProcessingHistoryDialog({ setOpen, open, user }) {
  const { t } = useTranslation();
  const [displayedData, setDisplayedData] = useState([]);

  // Helper function: traverse user.projects → each project.data → each processing_request,
  // and collect only those records with done===true.
  function extractProcessingHistoryFromUser(user) {
    let history = [];
    // Assuming user.projects is an array of project objects.
    user.projects.forEach(project => {
      // Adjust this according to your project structure: here we assume each project has a 'data' array.
      if (project.data && Array.isArray(project.data)) {
        project.data.forEach(file => {
          if (
            file.processing_requests &&
            Array.isArray(file.processing_requests)
          ) {
            file.processing_requests.forEach(pr => {
              // Filter for those processing requests that are marked done.
              if (pr.done === true) {
                // Build a history object for the row.
                history.push({
                  // Project name (you can adjust: project.name or project.title)
                  project: project.title || "Unknown project",
                  // File name (from file.title or file.fileName)
                  file: file.filename || "Unknown file",
                  // Processing title: nested in the processing relation.
                  processing: pr.processing.title,
                  // Created date.
                  date: pr.updatedAt || "",
                  // Optionally include more fields if needed.
                  // You might also include the full pr object if your row component requires it.
                  prData: pr,
                });
              }
            });
          }
        });
      }
    });
    return history;
  }

  useEffect(() => {
    //console.log(user)
    if (user && user.projects) {
      const history = extractProcessingHistoryFromUser(user);
      //console.log(history)
      setDisplayedData(history);
    }
  }, [user]);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth='md' fullWidth>
      <Box sx={{ p: 2 }}>
        <DialogTitle>
          <Typography variant="h4" component="div">
            {t("ProcessingOptions")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: 4 }}>
          <Box>
            <Card             
            sx={{ 
              p: 0,
              '&:hover': {
                boxShadow: '0px 5px 22px rgba(0, 0, 0, 0.06), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.04)',
                transform: 'none',
              }
            }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Project")}</TableCell>
                    <TableCell>{t("File")}</TableCell>
                    <TableCell align="right">{t("Requests")}</TableCell>
                    <TableCell align="right" sx={{ width: 40 }}>{t("Date")}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {displayedData.map((row, index) => (
                    <ProcessingRequestRow key={index} project={row.project} file={row.file} processing={row.processing} date={row.date}/>
                  ))}
                </TableBody>
              </Table>
            </Card>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleClose}>
            {t("Close")}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
